export default __webpack_public_path__ + "static/media/radiusLogo.0ac3fab5.png";